import { render, staticRenderFns } from "./claim.vue?vue&type=template&id=fb91666a&scoped=true&"
import script from "./claim.vue?vue&type=script&lang=js&"
export * from "./claim.vue?vue&type=script&lang=js&"
import style0 from "./claim.vue?vue&type=style&index=0&id=fb91666a&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../../tmp/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fb91666a",
  null
  
)

export default component.exports